import React from 'react';
import styles from './Skills.module.css';

// Example skill set — adjust or expand as needed
const skills = [
  { name: 'HTML & CSS', description: 'Semantic & responsive design' },
  { name: 'JavaScript', description: 'Vanilla JS + frameworks' },
  { name: 'React', description: 'Hooks, context, & component design' },
  { name: 'Node.js', description: 'RESTful APIs & backend logic' },
  { name: 'Express', description: 'Fast, minimalist web framework' },
  { name: 'MongoDB', description: 'NoSQL database & Mongoose' },
  { name: 'Redux', description: 'State management' },
  { name: 'TypeScript', description: 'Typed superset of JavaScript' },
  { name: 'Git & GitHub', description: 'Version control & collaboration' },
  { name: 'Next.js', description: 'Server-side rendering & routing' },
  { name: 'Tailwind CSS', description: 'Utility-first CSS framework' },
  { name: 'Bootstrap', description: 'Popular CSS framework' },
  { name: 'Webpack', description: 'Module bundler' },
  { name: 'Jest', description: 'Unit testing framework' },
  { name: 'GraphQL', description: 'API query language' },
  { name: 'REST APIs', description: 'Architectural style for web services' },
  { name: 'UI/UX Fundamentals', description: 'Clean, user-friendly designs' },
  { name: 'AWS', description: 'Cloud services & deployments' },
  // ... add more if needed
];

const Skills = () => {
  return (
    <section id="skills" className="section">
      <div className="container">
        <h2>Skills</h2>
        <hr />
        <div className={styles.skillsGrid}>
          {skills.map((skill, i) => (
            <div className={styles.skillCard} key={i}>
              <h3>{skill.name}</h3>
              <p>{skill.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
